<template>
  <div class="container">
    <second-level>
      <div class="title">
        <h3 class="chinese">服务流程</h3>
        <div class="inner">
          <h3 class="english">Service Flow</h3>
          <p class="line"></p>
        </div>
      </div>
    </second-level>
    <service-flow></service-flow>
    <product-card></product-card>
  </div>
</template>

<script>
import ServiceFlow from "./ServiceFlow";
import SecondLevel from "../../SecondLevel";
import ProductCard from "./ProductCard";
export default {
  name: "Index",
  components: {
    SecondLevel,
    ServiceFlow,
    ProductCard
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 75%;
  margin: 0 auto;
}
</style>
